export default "__VITE_ASSET__maVQRK8M__"